import * as R from 'ramda';

export const mapLendersFromJson = R.compose(json => {
  return {
    lender_id: R.defaultTo("-", json['lender_id']),
    name: R.defaultTo("-", json['lender_name']),
    email: R.defaultTo("-", json['email']),
  };
}, R.defaultTo({}));

export const mapTransactionsFromJson = R.compose(json => {
  return {
    id: R.defaultTo("-", json['id']),
    lender_id: R.defaultTo("-", json['lender_id']),
    transaction_id: R.defaultTo("-", json['transaction_no']),
    lender_name: R.defaultTo("-", json['lender_name']),
    transaction_date: R.defaultTo("-", json['trans_at']),
    transaction_type: R.defaultTo("-", json['type']),
    transaction_amount: R.defaultTo("-", json['amount'])
  };
}, R.defaultTo({}));

export const mapTransactionSummaryFromJson = R.compose(json => {
  return {
    total_lender_funding_amount: R.defaultTo("-", json['total_funding_amount']),
    remaining_funding_amount: R.defaultTo("-", json['remaining_amount'])
  }
}, R.defaultTo({}))
